<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-06 15:35:08
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-09 19:48:45
-->
<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-05 21:42:33
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-06 01:07:15
-->
<template>
  <div class="table">
    <a-tabs>
      <a-tab-pane key="1" tab="需求管理">
        <!-- <div class="tool-box">
          <a-button @click="handleAdd" type="primary">发布</a-button>
        </div> -->
      </a-tab-pane>
    </a-tabs>
    <a-form :model="form2" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="标题">
        <a-input v-model="form2.title" maxLength="200" />
      </a-form-item>
      <a-form-model-item label="需求标签">
        <template v-for="tag in form2.maturity">
          <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
            <a-tag :key="tag" :closable="true" @close="() => handleClose(tag)">
              {{ `${tag.slice(0, 20)}...` }}
            </a-tag>
          </a-tooltip>
          <a-tag v-else :key="tag" @close="() => handleClose(tag)">
            {{ tag }}
          </a-tag>
        </template>
        <a-input
          v-if="inputVisible"
          ref="input"
          type="text"
          size="small"
          :style="{ width: '78px' }"
          :value="inputValue"
          @change="handleInputChange"
          @blur="handleInputConfirm"
          @keyup.enter="handleInputConfirm"
        />
        <a-tag style="background: #fff; borderstyle: dashed" @click="showInput">
          <a-icon type="plus" /> 新标签
        </a-tag>
      </a-form-model-item>
      <a-form-item label="联系人">
        <a-input v-model="form2.contact" maxLength="50" />
      </a-form-item>
      <a-form-item label="联系电话">
        <a-input
          v-model="form2.phone"
          maxLength="11"
          @change="handleTel()"
          style="width: 566px"
        />
      </a-form-item>
      <a-form-item label="交易金额">
        <a-input
          v-model="form2.money"
          maxLength="11"
          @change="handleTel1()"
          style="width: 566px"
        />
      </a-form-item>
      <a-form-item label="附件">
        <a-upload
          :showUploadList="false"
          :locale="locale"
          name="file"
          action="/newapp/api/common/attachment/"
          @change="handleChange"
        >
          <a-button> <a-icon type="upload" /> 上传 </a-button>
        </a-upload>

        <viewer>
          <img
            :src="
              form2.imgIdUrl
                ? form2.imgIdUrl
                : defaultImg
            "
            style="margin: 8px; cursor: pointer"
            width="555"
            height="315"
          />
        </viewer>
        <!-- <img  width="50" height="60" :src="'/app/common/attachment?id=' + attmentId" /> -->
      </a-form-item>

      <a-form-item label="内容">
        <!-- <div id="editor"></div> -->
        <quill-editor
          v-model="form2.remark"
          ref="myQuillEditor"
          :options="editorOption"
          @focus="onEditorFocus($event)"
          @blur="onEditorBlur($event)"
          @change="onEditorChange($event)"
        >
        </quill-editor>
        <!-- <a-textarea v-model="form.content" :disabled="!isEdit" /> -->
      </a-form-item>

      <a-form-item :wrapper-col="{ span: 12, offset: 5 }" style="margin: auto">
        <a-button
          type="primary"
          @click="$router.push({ path: '/userCenter/demand' })"
          style="width: 120px"
        >
          返回
        </a-button>
        <a-button
          type="primary"
          @click="handleOk"
          style="width: 120px; margin-left: 50px"
        >
          提交
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; // 调用富文本编辑器
import quillConfig from "@/util/quill-config.js";
import request from "../util/request";
import qs from "qs";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
const defaultImg = require("../assets/default.png");
export default {
  name: "user-center-project",
  components: {
    quillEditor,
  },
  data() {
    return {
      locale,
      defaultImg,
      editorOption: quillConfig,
      data: [],
      type: [],
      org: [],
      page: {
        page: 1,
        pageSize: 999,
      },
      title: "",
      visible: false,
      visible2: false,
      confirmLoading: false,
      inputVisible: false,
      inputValue: "",
      isEdit: true,
      parents: [],
      form: {
        maturity: [],
      },
      status: ["提交资料中", "申诉中", "申诉成功", "申诉失败"],
      userInfo: {},
      form2: {
        maturity: [],
      },
      industry: [],
      area: [],
      maturity: [],
      trade: [],
      projectType: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
    };
  },
  mounted() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
    }
    this.queryList();
    this.queryDict();
    this.queryOrg();
    this.queryArea();
    this.queryIndustry();
    this.queryMaturity();
    this.queryMode();
    this.queryProjectType();
  },
  methods: {
    onEditorBlur(editor) {
      console.log("editor blur!", editor);
    },
    onEditorFocus(editor) {
      console.log("editor focus!", editor);
    },
    onEditorReady(editor) {
      console.log("editor ready!", editor);
    },
    onEditorChange({ editor, html, text }) {
      console.log("editor change!", editor, html, text);
      this.content = html;
    },

    fmtStatus(text) {
      if (text == 0) {
        return "提交资料中";
      } else if (text == 1) {
        return "等待商标审核";
      } else if (text == 2) {
        return "提交商标局";
      } else if (text == 3) {
        return "申请成功";
      }
    },
    queryMaturity() {
      request({
        url: "/api/client/common/select/dict/list",
        params: { key: "PROJECT_MATURITY" },
      }).then((res) => {
        this.maturity = res.data;
      });
    },
    queryArea() {
      request({
        url: "/api/client/common/select/area",
      }).then((res) => {
        this.area = res.data;
      });
    },
    queryIndustry() {
      request({
        url: "/api/client/common/select/industry",
      }).then((res) => {
        this.industry = res.data;
      });
    },
    queryMode() {
      request({
        url: "/api/client/common/select/dict/list",
        params: { key: "MONEY_MODE" },
      }).then((res) => {
        this.trade = res.data;
      });
    },
    queryProjectType() {
      request({
        url: "/api/client/common/select/dict/list",
        params: { key: "PROJECT_TYPE" },
      }).then((res) => {
        this.projectType = res.data;
      });
    },
    handleTel() {
      if (isNaN(this.form2.phone)) {
        this.form2.phone = "";
      }
    },
    handleTel1() {
      if (isNaN(this.form2.money)) {
        this.form2.money = "";
      }
    },
    handleChange(info) {
      if (info.file.status === "done") {
        this.form2.imgId = info.file.response.data.url;
        this.form2.imgIdUrl = info.file.response.data.url;
        this.$message.success(`${info.file.name} 文件上传成功`);
      }
    },
    onDelete(record) {
      request({
        url: "/api/center/order/demand/" + record.id,
        method: "delete",
      }).then((res) => {
        this.$message.info(res.msg);
        this.queryList();
      });
    },
    handleAdd() {
      this.title = "新增";
      this.isEdit = true;
      this.form2 = {};
      this.visible2 = true;
    },
    handleEdit(record) {
      this.visible2 = true;
      this.title = "修改";
      //  this.form2  = JSON.parse(JSON.stringify(record));
      request({
        url: "/api/center/demand/" + record.id,
        method: "get",
      }).then((res) => {
        if (res.code == "200") {
          this.form2 = res.data;
          this.form2.contact = res.data.concat;
        } else {
          this.$message.error(res.msg);
        }
      });
      this.isEdit = true;
    },
    handleOk() {
      const params = Object.assign({}, this.form2);
      if (typeof params.maturity == "object") {
        params.maturity = params.maturity.join(",");
      }
      if (
        typeof params.title == "undefined" ||
        params.title == null ||
        params.title == ""
      ) {
        this.$message.error("标题不能为空");
        return false;
      }
      if (
        typeof params.maturity == "undefined" ||
        params.maturity == null ||
        params.maturity == ""
      ) {
        this.$message.error("标签不能为空");
        return false;
      }
      if (
        typeof params.contact == "undefined" ||
        params.contact == null ||
        params.contact == ""
      ) {
        this.$message.error("联系人不能为空");
        return false;
      }
      if (
        params.legalPersonPhone &&
        !/^1[1356789]\d{9}$/.test(params.legalPersonPhone)
      ) {
        this.$message.warning("联系电话不符合规范");
        return false;
      }
      if (
        typeof params.phone == "undefined" ||
        params.phone == null ||
        params.phone == ""
      ) {
        this.$message.error("联系电话不能为空");
        return false;
      }
      if (params.phone && !/^1[1356789]\d{9}$/.test(params.phone)) {
        this.$message.warning("联系电话不符合规范");
        return false;
      }
      if (
        typeof params.money == "undefined" ||
        params.money == null ||
        params.money == ""
      ) {
        this.$message.error("金额不能为空");
        return false;
      }
      if (
        typeof params.imgId == "undefined" ||
        params.imgId == null ||
        params.imgId == ""
      ) {
        this.$message.error("请上传图片");
        return false;
      }
      if (
        typeof params.remark == "undefined" ||
        params.remark == null ||
        params.remark == ""
      ) {
        this.$message.error("内容不能为空");
        return false;
      }

      if (this.isEdit) {
        request({
          url: "/api/center/demand/",
          method: "post",
          data: qs.stringify(params),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }).then((res) => {
          if (res.code == "200") {
            this.$message.info("操作成功");
            this.visible2 = false;
            this.form2 = {};
            this.queryList();
            this.$router.push({ path: "/userCenter/demand" });
          } else {
            this.$message.warning(res.msg);
          }
        });
      } else {
        this.visible2 = false;
        this.form2 = {};
      }
    },
    fmttype(text) {
      const result = this.type.find((ele) => ele.key == text);
      return result ? result.value : "";
    },
    fmtAgency(text) {
      const result = this.org.find((ele) => ele.key == text);
      return result ? result.value : "";
    },
    queryDict() {
      request({
        url: "/api/tool/select/dict/list",
        params: {
          key: "PROJECT_TYPE",
        },
      }).then((res) => {
        console.log("dict", res);
        this.type = res.data;
      });
    },

    queryOrg() {
      request({
        url: "/api/tool/select/enterprise/list",
        params: {
          key: "ORG_OWNER",
        },
      }).then((res) => {
        this.org = res.data;
      });
    },
    queryList() {
      request({
        url: "/api/center/demand/list",
        params: this.page,
      }).then((res) => {
        if (res.code == "200") {
          this.data = res.data.records;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.form2 = false;
    },
    handleClose(removedTag) {
      let tags = this.form.maturity;
      tags = tags.filter((tag) => tag !== removedTag);
      this.form2.maturity = tags;
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.input.focus();
      });
    },
    handleInputChange(e) {
      this.inputValue = e.target.value;
    },

    handleInputConfirm() {
      const inputValue = this.inputValue;
      let tags = this.form2.maturity;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags);
      this.$set(this.form2, "maturity", tags);
      Object.assign(this, {
        inputVisible: false,
        inputValue: "",
      });
    },
  },
};
</script>

<style lang="less"></style>
